// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","settings":"bwQ6Q1fDI2Ks0EOA","title":"i84us86v3uDQ2mqh","subtitle":"i_w4UsZflTEHSVHB","error":"Rvdh6ujNbraKsmN3"};